import { Link } from "react-router-dom";
import type { Screening } from "@/types/content";

interface ScreeningListProps {
  items: Screening[];
}

export default function ScreeningList({ items }: ScreeningListProps) {
  if (items.length === 0) {
    return (
      <div className="rounded-lg border border-background-200/70 bg-background-100 p-12 text-center">
        <i className="ri-calendar-close-line text-4xl text-foreground-500" />
        <h3 className="font-heading font-semibold text-foreground-950 mt-4 mb-2">当日暂无放映场次</h3>
        <p className="text-sm text-foreground-600">请选择日历上有标记的日期，或切换其他筛选条件</p>
      </div>
    );
  }

  return (
    <ul className="flex flex-col gap-3">
      {items.map((item) => (
        <li key={item.id}>
          <Link
            to={`/films/${item.filmId}`}
            className="group flex flex-col sm:flex-row sm:items-center gap-4 p-5 rounded-lg bg-background-100 border border-background-200/70 hover:border-accent-500/60 transition-colors cursor-pointer"
          >
            <div className="flex items-center gap-4 flex-1 min-w-0">
              <div className="flex flex-col items-center justify-center w-20 h-16 rounded-lg bg-accent-500/10 shrink-0">
                <span className="font-heading font-bold text-lg text-accent-500">{item.time}</span>
                <span className="text-[11px] text-foreground-500 font-label">开映</span>
              </div>
              <div className="min-w-0">
                <h3 className="font-heading font-semibold text-foreground-950 truncate group-hover:text-accent-500 transition-colors">
                  {item.filmTitle}
                </h3>
                <p className="text-xs text-foreground-500 mt-1.5 flex flex-wrap items-center gap-x-4 gap-y-1">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-building-2-line" />
                    {item.hall}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-cpu-line" />
                    {item.tech}
                  </span>
                </p>
              </div>
            </div>
            <div className="flex items-center justify-between sm:justify-end gap-4 shrink-0">
              <span className="font-heading font-bold text-lg text-accent-500 whitespace-nowrap">
                ¥{item.price}
              </span>
              <span className="inline-flex items-center gap-1 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-label whitespace-nowrap">
                查看详情
                <i className="ri-arrow-right-s-line" />
              </span>
            </div>
          </Link>
        </li>
      ))}
    </ul>
  );
}